import { ApiResponse } from "apisauce";
import { Api } from "./api";
import { getGeneralApiProblem } from "./api-problem";

export class CardsApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getCards(): Promise<any> {
    try {
      const response: ApiResponse<never> = await this.api.apisauce.get(
        `/cards`
      );
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const { data } = response;
      return data;
    } catch (error) {
      return { kind: "bad-data" };
    }
  }
}
